import { useEffect } from 'react';

const PARIS_DOMAIN = 'https://paris.cl';
const PARIS_DOMAIN_WWW = 'https://www.paris.cl';
const PARIS_BETA_DOMAIN = 'https://beta.paris.cl';
const PARIS_NEW_DOMAIN = 'https://nuevo.paris.cl';

const hasOldParisDomain = (origin: string) =>
  origin === PARIS_DOMAIN || origin === PARIS_DOMAIN_WWW;

const hasNewParisDomain = (origin: string) =>
  origin === PARIS_BETA_DOMAIN || origin === PARIS_NEW_DOMAIN;

const useFingerPrint = (customerId: string) => {
  useEffect(() => {
    if (!customerId) return;

    const origin = window?.location?.origin;
    let orgID = '1snn5n9w';

    const isOldParisDomain = hasOldParisDomain(origin);
    const isNewParisDomain = hasNewParisDomain(origin);

    if (isOldParisDomain || isNewParisDomain) {
      orgID = 'k8vif92e';
    }

    const scriptElement = document.createElement('script');
    scriptElement.type = 'text/javascript';
    scriptElement.src = `https://h.online-metrix.net/fp/tags.js?org_id=${orgID}&session_id=cencosud${customerId}`;

    const iframeElement = document.createElement('iframe');
    iframeElement.style.width = '1px';
    iframeElement.style.height = '1px';
    iframeElement.style.border = '0';
    iframeElement.style.position = 'absolute';
    iframeElement.style.top = '-5000px';
    iframeElement.src = `https://h.online-metrix.net/fp/tags?org_id=${orgID}&session_id=cencosud${customerId}`;

    document.head.appendChild(scriptElement);
    document.head.appendChild(iframeElement);
  }, [customerId]);
};

export default useFingerPrint;
